import PropTypes from 'prop-types';
import clsx from 'clsx';

const Item = ({
  children,
  variant,
  lowWidth,
  classes,
  withGridLayout,
}) => {
  const className = clsx(
    'w-full px-4 py-2 text-sm text-gray-700 rounded-2xl',
    lowWidth ? 'grid-cols-10' : 'grid-cols-5',
    classes,
    {
      grid: withGridLayout,
      'hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900 hover:bg-gray-100': variant === 'select',
    },
  );
  return (
    <div
      className={className}
      role="menuitem"
    >
      {children}
    </div>
  );
};

Item.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  lowWidth: PropTypes.bool,
  classes: PropTypes.string,
  withGridLayout: PropTypes.bool,
};

Item.defaultProps = {
  children: undefined,
  variant: undefined,
  classes: undefined,
  lowWidth: false,
  withGridLayout: true,
};

export default Item;
